"use client";

import React from "react";

import config from "configs/app";

import styles from "./TopBarStats.module.css";

const TopBarStats = () => {
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => {
    setMounted(true);
  }, []);
  const [ogpuPrice, setOgpuPrice] = React.useState<{
    price: number | null;
    change: number | null;
  }>({ price: null, change: null });
  const [gasPrice, setGasPrice] = React.useState<{
    slow: number;
    average: number;
    fast: number;
  } | null>(null);

  React.useEffect(() => {
    const fetchOgpuPrice = async () => {
      const url = "/backend/ogpu-price";
      try {
        const res = await fetch(url);
        const json = await res.json();
        if (json["open-gpu"]) {
          setOgpuPrice({
            price: json["open-gpu"].usd,
            change: json["open-gpu"].usd_24h_change ?? null,
          });
          return;
        }
        if (json.price !== undefined && json.price !== null) {
          setOgpuPrice({ price: json.price, change: json.change ?? null });
          return;
        }
      } catch {
        // try next url
      }
    };

    fetchOgpuPrice();
    const interval = setInterval(fetchOgpuPrice, 60 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  React.useEffect(() => {
    const fetchGasPrice = async () => {
      try {
        const res = await fetch("https://ogpuscan.io/api/v1/gas-price-oracle");
        const json = await res.json();
        setGasPrice({
          slow: json.slow,
          average: json.average,
          fast: json.fast,
        });
      } catch {
        // silent
      }
    };

    fetchGasPrice();
    const interval = setInterval(fetchGasPrice, 30000);
    return () => clearInterval(interval);
  }, []);

  const coinPrice = ogpuPrice.price !== null ? String(ogpuPrice.price) : null;
  const coinChange = ogpuPrice.change;

  if (!mounted) {
    return (
      <div className={styles.container}>
        <div className={styles.priceGroup}>
          <span className={styles.label}>{config.chain.currency.symbol} </span>
          <span className={styles.skeleton} />
        </div>
        <span className={styles.separator}>|</span>
        <div className={styles.gasGroup}>
          <span className={styles.label}>Gas </span>
          <span className={styles.skeleton} style={{ width: "50px" }} />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {coinPrice ? (
        <div className={styles.priceGroup}>
          <span className={styles.priceText}>
            <span className={styles.label}>
              {config.chain.currency.symbol}{" "}
            </span>
            <span>
              $
              {Number(coinPrice).toLocaleString(undefined, {
                minimumFractionDigits: 4,
                maximumFractionDigits: 4,
              })}
            </span>
          </span>
          {coinChange !== null && coinChange !== undefined && (
            <span
              className={
                Number(coinChange) >= 0
                  ? styles.changePositive
                  : styles.changeNegative
              }
            >
              {Number(coinChange).toFixed(2)}%
            </span>
          )}
        </div>
      ) : (
        <div className={styles.priceGroup}>
          <span className={styles.label}>{config.chain.currency.symbol} </span>
          <span className={styles.skeleton} />
        </div>
      )}
      <span className={styles.separator}>|</span>
      {gasPrice ? (
        <div className={styles.gasGroup}>
          <span className={styles.label}>Gas </span>
          <span>{gasPrice.average} Gwei</span>
        </div>
      ) : (
        <div className={styles.gasGroup}>
          <span className={styles.label}>Gas </span>
          <span className={styles.skeleton} style={{ width: "50px" }} />
        </div>
      )}
    </div>
  );
};

export default React.memo(TopBarStats);
